import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Global HTTP interceptor for 404 responses.
 *
 * Currently a pass-through. API 404s are handled at the page level:
 * - Listing page: uses HANDLE_404_LOCALLY token + RestError.isNotFound for inline error state
 * - Unknown URLs: wildcard route renders NotFoundPage which redirects home via ErrorService
 *
 * This interceptor is kept as a hook for future global 404 handling if needed.
 * Pages that handle 404s locally use the HANDLE_404_LOCALLY HttpContext token
 * (see error.tokens.ts) so they can be distinguished from unhandled 404s.
 */
@Injectable()
export class NotFoundInterceptor implements HttpInterceptor {
	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request);
	}
}
